import React, { useState } from "react";
import "./Contact.css";

import flecha from "../../assets/flecha-link.png";

function Contact() {
  const [formData, setFormData] = useState({
    nom: "",
    cognom: "",
    missatge: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here
    console.log(formData);
  };

  return (
    <section className="contact">
      <h1>Contacte</h1>
      <div className="contact-container">
        <h3 className="contact-subtitle">PER QUÈ ENS CONTACTES?</h3>

        <div className="contact-buttons">
          <button
            className="contact-btn"
            onClick={() =>
              document
                .querySelectorAll(".contact-btn")
                .forEach((btn) => btn.classList.remove("active")) ||
              document
                .querySelectorAll(".contact-btn")[0]
                .classList.add("active")
            }
          >
            BOTIGA
          </button>
          <button
            className="contact-btn"
            onClick={() =>
              document
                .querySelectorAll(".contact-btn")
                .forEach((btn) => btn.classList.remove("active")) ||
              document
                .querySelectorAll(".contact-btn")[1]
                .classList.add("active")
            }
          >
            INFORMACIÓ
          </button>
        </div>

        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <input
                type="text"
                name="nom"
                value={formData.nom}
                onChange={handleChange}
                placeholder="NOM"
                className="form-input"
                required
              />
            </div>

            <div className="form-group">
              <input
                type="text"
                name="cognom"
                value={formData.cognom}
                onChange={handleChange}
                placeholder="COGNOM"
                className="form-input"
                required
              />
            </div>
          </div>

          <div className="form-group full-width">
            <textarea
              name="missatge"
              value={formData.missatge}
              onChange={handleChange}
              placeholder="MISSATGE"
              className="form-input"
              required
              rows={4}
            />
          </div>

          <div className="form-submit">
            <button type="submit" className="submit-btn">
              ENVIAR <img src={flecha} alt="arrow" className="footer-arrow" />
            </button>
          </div>
        </form>
      </div>
    </section>
  );
}

export default Contact;
